import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { requestContentPages } from "~/store/resource/resourceAction";
import { Delpath } from "~/utils/constants";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const UsageRulesPage = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/UsageRulesTest"),
  loading: LoadableLoading
});
class DetectUsageRules extends Component {
  componentDidMount() {
    const pathName = Delpath(this.props.location.pathname);
    this.props.requestContentPages(pathName);
  }

  render() {
    return (
      <React.Fragment>
        <UsageRulesPage {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { ContentPages }
  } = state;
  return {
    device: type,
    ContentPages
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestContentPages: pathName => dispatch(requestContentPages(pathName)) // có
  };
};
const UsageRulesHelmet = withTitle({
  component: DetectUsageRules,
  title: `${hospitalName.value} | Quy định sử dụng`
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageRulesHelmet);
